import { render, staticRenderFns } from "./ArtAI.vue?vue&type=template&id=2ca70554"
import script from "./ArtAI.vue?vue&type=script&lang=js"
export * from "./ArtAI.vue?vue&type=script&lang=js"
import style0 from "./ArtAI.vue?vue&type=style&index=0&id=2ca70554&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports